import { Link } from "react-router";
import { Logo } from "~/components/logo";
import { GetStartedButton } from "./get-started-button";
// import { Sheet, SheetContent, SheetTrigger } from "~/components/ui/sheet";

export function Header() {
  return (
    <header className="py-4">
      <div className="container flex h-16 items-center justify-between px-4">
        <Link to="/" prefetch="intent">
          <Logo />
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          {/* <Link to="#features" className="font-medium hover:underline">
            Features
          </Link>
          <Link to="#pricing" className="font-medium hover:underline">
            Pricing
          </Link>
          <Link to="/blog" className="font-medium hover:underline">
            Blog
          </Link> */}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <GetStartedButton />
        </div>

        {/* <Sheet>
          <SheetTrigger asChild>
            <Button variant="outline" size="icon" className="md:hidden">
              <MenuIcon className="h-5 w-5" />
              <span className="sr-only">Toggle menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent
            side="left"
            className="w-[300px] border-r-4 border-black"
          >
            <nav className="flex flex-col gap-4">
              <Link
                href="#features"
                className="text-lg font-semibold hover:underline"
              >
                Features
              </Link>
              <Link
                href="#pricing"
                className="text-lg font-semibold hover:underline"
              >
                Pricing
              </Link>
              <Link
                href="#testimonials"
                className="text-lg font-semibold hover:underline"
              >
                Testimonials
              </Link>
              <Link
                href="/blog"
                className="text-lg font-semibold hover:underline"
              >
                Blog
              </Link>
              <Link
                href="/login"
                className="text-lg font-semibold hover:underline"
              >
                Log in
              </Link>
              <Link
                href="/signup"
                className="text-lg font-semibold hover:underline"
              >
                Sign up
              </Link>
            </nav>
          </SheetContent>
        </Sheet> */}
      </div>
    </header>
  );
}
